export enum BlacklistUseE {
  CASUAL_CHAT = 'CASUAL_CHAT',
  CAMPAIGN = 'CAMPAIGN',
  WORKFLOW = 'WORKFLOW',
  CALL = 'CALL',
}
